import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ThemeProvider as StyledProvider } from 'styled-components'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { PersistGate } from 'redux-persist/integration/react'
import MomentUtils from '@date-io/moment'
import * as Sentry from '@sentry/browser'

import defaultTheme, { materialTheme } from 'utils/theme'
import { store, persistor } from 'redux/store'
import './index.css'
import Router from './router'

if (process.env.NODE_ENV === 'production') {
  Sentry.onLoad(() => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_ENVIRONMENT,
    })
  })
}
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <StyledEngineProvider injectFirst>
        <StyledProvider theme={defaultTheme}>
          <ThemeProvider theme={materialTheme}>
            <LocalizationProvider dateAdapter={MomentUtils}>
              <ToastContainer />
              <Router />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledProvider>
      </StyledEngineProvider>
    </PersistGate>
  </Provider>,
)
